import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, message } from 'antd';
import SubmitPasswordRecoveryForm from '../../forms/passwordRecovery/SubmitPasswordRecoveryForm';
import { submitPasswordRecoveryService } from '../../../../services/login/Login.api';
import useTranslation from '../../../hooks/translation/useTranslation';
import formSetDynamicErrors from '../../../../utils/functions/formSetDynamicErrors';
import isMobile from '../../../../utils/functions/isMobile';

function PasswordRecovery() {
  const { trans } = useTranslation();

  const [form] = Form.useForm();

  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!window?.ReactNativeWebView && isMobile()) {
      window.location.href = `georgian-railway:/${window.location.href}`;
    }
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (code) {
        await submitPasswordRecoveryService({ ...values, code });
        navigate('/');
        message.success(trans('password_recovered_successfully'));
      }
    } catch (e) {
      formSetDynamicErrors({
        e,
        form,
      });
    }
  };
  return (
    <div className="py-10 flex items-center justify-center">
      <div className="w-full max-w-[500px]">
        <SubmitPasswordRecoveryForm form={form} handleSubmit={handleSubmit} />
      </div>
    </div>
  );
}

export default PasswordRecovery;
